/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2015, 2025. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
'use strict';

var requireServer = require('./require-server'),
  jsonPayload = require('../client/json-payload'),
  nconf = requireServer('nconf');

/*
 * Exposes the subset of the app configuration that is accessible to the views on the server
 * and on the client. We don't expose the entire configuration as it may contain secure values
 * that should not be in the browser.
 */

var WHITELIST = ['AUTOMATION_CONTEXT_PATH', 'CHAT_URL', 'CONSOLE_URL', 'CONSOLE_MESSAGE', 'CONTEXT_PATH', "CD_SERVICE_IDS", 'DEVEX_PATH', 'DOCS_URL', 'OPTIMIZELY_ID', 'SEGMENT_SOURCE_KEY', 'ENABLE_CHATBOT', 'ENV_ID', 'REGION_ID', 'TOOLCHAIN_PAGE_UPDATE_INTERVAL', 'WELCOME_FEATURED_ITEMS', 'WELCOME_FEATURED_ITEMS_DEPRECATED', 'WELCOME_RELATED_SERVICES'];
var config = {};
if (nconf) {
  WHITELIST.forEach(function (i) {
    config[i] = nconf.get(i);
  });
} else {
  config = jsonPayload.get('config');
}
module.exports = config;